import type { ReactNode } from "react";

type Props = {
  icon?: string;
  title: string;
  text?: string;
  action?: ReactNode;
};

export default function EmptyState({
  icon = "pi pi-inbox",
  title,
  text,
  action,
}: Props) {
  return (
    <div className="empty">
      <span className="empty__icon">
        <i className={icon} aria-hidden="true" />
      </span>
      <p className="empty__title">{title}</p>
      {text && <p className="empty__text">{text}</p>}
      {action}
    </div>
  );
}
